import request from 'sb-request'
import { reducers } from 'redux/core'


const fetch = (orderId) => {
  reducers.view.orderInfoPage.setFetchingStatus(true)

  request.get(`rest/profile/order?id=${orderId}`, {
    modifyResult: ({ items, orderId }) => ({
      orderId,
      products: (items || []).map(({ img, price, amount, url, id, name }) => ({
        total: amount * price * 100,
        price: price * 100,
        quantity: amount,
        name,
        img,
        url,
        id,
      })),
    }),
  })
    .then(
      (items) => reducers.view.orderInfoPage.setItems(items),
      () => {
        reducers.view.orderInfoPage.setFetchingStatus(false)
        return Promise.reject()
      }
    )
}

// eslint-disable-next-line
const reset = reducers.view.orderInfoPage.reset

export default {
  fetch,
  reset,
}
